import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import DocumentListItem from '@/components/document-list-item.vue';
import { useRepositories } from '@/plugins/repositories';
import { shopifyDocDetailsUrl } from '@/utils/shopifyUtils';
var PER_PAGE = 20;
export default defineComponent({
  components: {
    DocumentListItem: DocumentListItem
  },
  setup: function setup() {
    var results = ref([]);
    var repositories = useRepositories();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return repositories.docs.recentlyAddedPurchasable(PER_PAGE);
          case 2:
            results.value = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      results: results,
      shopifyDocDetailsUrl: shopifyDocDetailsUrl
    };
  },
  head: function head() {
    return {
      title: '新着ストアコンテンツ'
    };
  }
});